import { AUTH_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TAuthSelector, TEqualityFunction } from '../types';

export const useAuthSelector = <TSelected>(selector: TAuthSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) => {
    return useCustomSelector<TSelected, typeof AUTH_REDUCER>(AUTH_REDUCER, selector, equalityFn);
};
